import React, { useEffect } from 'react'
import * as echarts from 'echarts'

const PaymentMethodsChart = ({ paymentData = [] }) => {
    useEffect(() => {
        const chartDom = document.getElementById('paymentMethodsChart')
        const myChart = echarts.init(chartDom)

        // Define colors for payment methods
        const colors = {
            CREDIT_CARD: '#5d8e9a',
            DEBIT_CARD: '#0c505b',
            APPLE_PAY: '#caa72b',
            WALLET: '#ebe2d6',
            OTHERS: '#aac1c6',
        }

        // Transform data using revenue_percentage directly
        const data = paymentData.map(item => ({
            value: item.revenue_percentage?.toFixed(2) || 0,
            name: item.payment_method || 'OTHERS',
            itemStyle: { color: colors[item.payment_method] || colors.OTHERS },
        }))

        const option = {
            tooltip: {
                trigger: 'item',
                formatter: function (params) {
                    return `${params.name}<br/>${params.value}%`
                },
            },
            graphic: {
                elements: [
                    {
                        type: 'text',
                        left: '22%',
                        top: '45%',
                        style: {
                            text: 'Payment\nMethods',
                            textAlign: 'center',
                            fill: '#64749A',
                            fontSize: window.innerWidth < 640 ? 12 : 16,
                            fontWeight: 'bold',
                        },
                    },
                ],
            },
            legend: {
                orient: 'vertical',
                right: '5%',
                top: 'center',
                itemWidth: window.innerWidth < 640 ? 8 : 10,
                itemHeight: window.innerWidth < 640 ? 20 : 30,
                itemGap: window.innerWidth < 640 ? 12 : 20,
                textStyle: {
                    fontSize: window.innerWidth < 640 ? 10 : 12,
                },
                icon: 'circle',
                formatter: name => {
                    const item = data.find(d => d.name === name)
                    return `${name} ${item.value}%`
                },
            },
            series: [
                {
                    name: 'Payment Methods',
                    type: 'pie',
                    radius: ['65%', '95%'],
                    center: ['30%', '50%'],
                    avoidLabelOverlap: false,
                    label: {
                        show: false,
                    },
                    labelLine: {
                        show: false,
                    },
                    data: data,
                    emphasis: {
                        scale: false,
                        itemStyle: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)',
                        },
                    },
                },
            ],
        }

        myChart.setOption(option)

        const handleResize = () => {
            myChart.resize()
        }
        window.addEventListener('resize', handleResize)

        // Initial resize to ensure proper rendering
        handleResize()

        return () => {
            window.removeEventListener('resize', handleResize)
            myChart.dispose()
        }
    }, [paymentData])

    return (
        <div className="relative w-full h-full">
            <div id="paymentMethodsChart" className="w-full h-[180px] sm:h-[230px]"></div>
        </div>
    )
}

export default PaymentMethodsChart
